import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';

export const Card = styled.div`
  position: relative;
  background-color: ${themeGet('colors.neutral_1')};
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 3px solid ${themeGet('colors.orange')};

  &.with-flag {
      &::after {
      content: "${({ flagValue }) => flagValue}";
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      min-height: 81.6px;
      width: 81.6px;
      border: 6px solid ${themeGet('colors.orange')};
      background-color: ${themeGet('colors.maroon')};

      font-weight: ${themeGet('font-weights.bold')};
      font-family: ${themeGet('fonts.primary')};
      color: ${themeGet('colors.white')};
      font-size: 20px;
      letter-spacing: -0.38px;
      line-height: 19.2px;
      text-align: center;

      position: absolute;
      top: -20px;
      right: 10px;
    }
  }

  &.default,
  &.Default {
  }

  &.priority,
  &.Priority {
  }

  &.secondary,
  &.Secondary {
    border: 3px solid ${themeGet('colors.ocean')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 535px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    &.with-flag {
      &::after {
      min-height: 102px;
      width: 102px;
      font-size: 24px;
      letter-spacing: -0.46px;
      line-height: 24px;
    }
  }
  }
`;

export const Header = styled.div`
  text-align: center;
  padding: 18px 0;

  h2, h3 {
    color: ${themeGet('colors.orange')};
    font-family: ${themeGet('fonts.secondary')};
    font-weight: normal;
    font-size: 26px;
    letter-spacing: 0;
    line-height: 30px;
  }

  ${Card}.priority &, ${Card}.Priority & {
    background-color: ${themeGet('colors.orange')};

    h2, h3 {
      color: ${themeGet('colors.white')};
    }
  }

  ${Card}.secondary &, ${Card}.Secondary & {
    background-color: ${themeGet('colors.ocean')};

    h2, h3 {
      color: ${themeGet('colors.white')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    h2, h3 {
      font-size: 32px;
      letter-spacing: 0.12px;
      line-height: 38px;
    }
  }
`;

export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 25px 40px 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 25px 20px 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 25px 40px 40px;
  }
`;

export const Details = styled.div`
  position: relative;
  padding-top: 36px;
  margin: 0 0 36px;
`;

export const Saving = styled.p`
  font-weight: ${themeGet('font-weights.bold')};
  line-height: 32px;
  text-align: center;
  color: ${themeGet('colors.orange')};
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const Pricing = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const StandardPrice = styled.p`
  line-height: 32px;
  text-align: center;
  margin-bottom: 8px;
  color: ${themeGet('charcoal-light')};

  /* This creates the strike through */
  background-color: transparent;

  background-image: gradient(
    linear,
    19.1% -7.9%,
    81% 107.9%,
    color-stop(0, transparent),
    color-stop(0.48, transparent),
    color-stop(0.5, #95a1ad),
    color-stop(0.52, transparent),
    color-stop(1, transparent)
  );

  background-image: repeating-linear-gradient(
    163deg,
    transparent 0%,
    transparent 48%,
    #95a1ad 50%,
    transparent 52%,
    transparent 100%
  );
`;

export const Price = styled.p`
  font-size: 79.2px;
  letter-spacing: -2.63px;
  line-height: 93px;
  text-align: center;

  span {
    font-weight: ${themeGet('font-weights.bold')};
    line-height: 32px;
    text-align: center;

    margin-left: 13px;
  }
`;

export const Conditions = styled.p`
  font-size: 18px;
  letter-spacing: -0.2px;
  line-height: 26px;
  text-align: center;
  min-height: 52px;

  &.small {
    position: absolute;
    min-height: auto;
    /* left: 50%; */
    transform: translateX(-50%);
    width: 100%;
    bottom: 10px;

    left: calc(100% * 0.5);
  }
`;

export const Copy = styled.div`
  margin: 0 0 40px;
`;

export const Label = styled.p`
  font-size: 22px;
  font-weight: ${themeGet('font-weights.bold')};
  letter-spacing: -0.5px;
  line-height: 32px;
`;

export const Features = styled.ul``;

export const Feature = styled.li`
  position: relative;
  /* The padding on the left is the spacing between the icon and list, and the icons height  */
  padding: 10px 0 10px 42px;
  display: flex;

  &:first-child {
    padding-top: 15px;
  }

  &::before {
    content: '';
    position: absolute;
    /* Negative left position equal to the spacing between icon and list */
    /* left: -16px; */
    left: 0;
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    height: 26px;
    width: 26px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: auto;
`;

export const Disclaimer = styled.p`
  font-size: 16px;
  font-weight: ${themeGet('font-weights.bold')};
  letter-spacing: 0;
  line-height: 28px;
  text-align: center;

  margin-bottom: 10px;
`;

export const StyledLink = styled(Link)`
  align-self: center;

  margin-bottom: 10px;
`;
